import cn from "classnames"
import React from "react"
import { CleanHtml } from "swiipe.portal.shared"
import "./OnboardingPricingLine.scss"

export interface IOnboardingPricingLine {
    className?: string
    priceHtml?: string
    children?: React.ReactNode
    enlargeSpans?: boolean
}
/**
 * This component is used to display a line of text with pricing information.
 * It both supports injecting HTML as we do in legacy ways and also supports injecting React components.
 */
export const OnboardingPricingLine = ({ className, priceHtml, children, enlargeSpans }: IOnboardingPricingLine) => {
    return (
        <div className={cn("onboarding-price-line", enlargeSpans && "onboarding-price-line--enlarge-spans", className)}>
            {priceHtml && <CleanHtml element="div" className={className} html={priceHtml} />}
            {children && children}
        </div>
    )
}

export default OnboardingPricingLine
